// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-dropdown[data-v-0204ac72] {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 32px;\n  border-radius: 32px;\n  padding: 0 10px;\n  cursor: pointer;\n  border: 1px solid #497CF6;\n}", ""]);
// Exports
module.exports = exports;
